// src/context/UserContext.js
import { createContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

export const OrgContext = createContext(null);

export const OrgProvider = ({ children }) => {
  const [orgs, setOrgs] = useState(null);

  useEffect(() => {
    console.log('Context orgs', orgs);
  }, [orgs]);

  return <OrgContext.Provider value={{ orgs, setOrgs }}>{children}</OrgContext.Provider>;
};

OrgProvider.propTypes = {
  children: PropTypes.node.isRequired, // Define the 'children' prop
};
